import { createContext, useContext } from "react"

import { getOptions } from "./getDemoData"

import type {
  AiPoliciesContextValue,
  AiPoliciesSource,
  AiPolicyFeatures
} from "./useAiPolicies.types"

export const AI_POLICY_FEATURES: Record<AiPoliciesSource, AiPolicyFeatures> = {
  demo: {
    allowRules: true,
    ruleActions: true,
    violations: true,
    agentRows: true,
    followers: true,
    editableScope: false,
    enforcement: false,
    listQuery: false
  },
  live: {
    allowRules: false,
    ruleActions: false,
    violations: false,
    agentRows: false,
    followers: false,
    editableScope: true,
    enforcement: true,
    listQuery: true
  }
}

export const PENDING_AI_POLICIES_CONTEXT: AiPoliciesContextValue = {
  source: "demo",
  features: AI_POLICY_FEATURES.demo,
  ruleOptions: getOptions(),
  isPending: true,
  mode: undefined,
  response: undefined,
  update: () => {},
  create: (record) => `${record.id}`,
  findById: () => undefined,
  findAgentPolicy: () => undefined,
  saveAgentPolicy: () => {
    throw new Error("saveAgentPolicy called before the policies loaded")
  },
  approveSuggestions: () => {
    throw new Error("approveSuggestions called before the policies loaded")
  }
}

export const AiPoliciesContext = createContext<AiPoliciesContextValue>(
  PENDING_AI_POLICIES_CONTEXT
)

export const useAiPolicies = () => {
  const context = useContext(AiPoliciesContext)

  if (context === undefined)
    throw new Error("useAiPolicies must be used within an AiPolicyProvider")

  return context
}
